<template>
    <teleport to="head">
        <title>{{ HEAD_TITLE }} | Plan de Estudios</title>
    </teleport>
    <UnauthNav />
    <div v-if="user.id">
        <MobileControls />
    </div>
    <IphoneBar />
    <div class="lcu-nonDash-wrap" :class="{ 'lcu-logged-dashWrap': user.id }">
        <SecondaryNav />
        <div class="lcu-page lcu-page-noSpacing">
            <HeroBanner :image="'/assets/heroes/LCU-Laptop-books.jpg'">
                <section class="section">
                    <h3 class="lcu-hero-h3 lcu-center-text">
                        LEGACY CHRISTIAN UNIVERSITY
                    </h3>
                    <h1 class="lcu-hero-h1 lcu-center-text">
                        Plan de Estudios
                    </h1>
                </section>
            </HeroBanner>
            <section class="section-public">
                <div class="section-container">
                    <div class="row">
                        <h2 class="lcu-curriculum-h2">
                            1. &nbsp;&nbsp;Teología
                        </h2>
                        <ul>
                            <li>TH201 - Los Atributos de Dios</li>
                            <li>TH202 - El Reino de Dios y el Reino de los Cielos</li>
                            <li>TH204 - Angelología y Demonología</li>
                        </ul>
                    </div>
                    <div class="row">
                        <h2 class="lcu-curriculum-h2">
                            2. &nbsp;&nbsp;Consejería Pastoral
                        </h2>
                        <ul>
                            <li>EM201 - Principios de Guerra Espiritual en la Consejería</li>
                            <li>CP301 - La Ministración, Sanidad y Liberación del Alma</li>
                            <li>CP302 - Los 8 Pasos a la Restauración</li>
                            <li>CP303 - El Poder de la Sanidad Divina</li>
                        </ul>
                    </div>
                    <div class="row">
                        <h2 class="lcu-curriculum-h2">
                            3. &nbsp;&nbsp;Ministerio Profético
                        </h2>
                        <ul>
                            <li>MP201 - Escuela Profética I</li>
                        </ul>
                    </div>
                    <div class="row">
                        <h2 class="lcu-curriculum-h2">
                            4. &nbsp;&nbsp;Estudios Religiosos
                        </h2>
                        <ul>
                            <li>SR401 - Sectas y Religiones</li>
                            <li>AC501 - Apologética Cristiana</li>
                        </ul>
                    </div>
                    <div class="row">
                        <h2 class="lcu-curriculum-h2">
                            5. &nbsp;&nbsp;Ética Cristiana
                        </h2>
                        <ul>
                            <li>EC180 - El Carácter y la Ética del Cristiano</li>
                        </ul>
                    </div>
                    <div class="row">
                        <h2 class="lcu-curriculum-h2">
                            6. &nbsp;&nbsp;Formación Ministerial
                        </h2>
                        <ul>
                            <li>L601 - Escuela de Formación de Líderes</li>
                        </ul>
                    </div>
                    <div class="row">
                        <h2 class="lcu-curriculum-h2">
                            7. &nbsp;&nbsp;Estudios Bíblicos
                        </h2>
                        <ul>
                            <li>B001 - Hermenéutica Bíblica</li>
                            <li>B002 - Homilética</li>
                            <li>B004 - Teología Fundamental</li>
                            <li>B005 - Estudio de la Neumatología</li>
                        </ul>
                    </div>
                </div>
            </section>
            <section class="section-public-gray">
                <div class="section-container">
                    <div class="col-2-thirds">
                        <div>
                            <div class="row">
                                <h2 class="lcu-h2">
                                    Herramientas Adicionales
                                </h2>
                            </div>
                            <div class="row">
                                Hay muchas herramientas que te facilitan en gran manera
                                el estudio de las escrituras, nosotros en la Universidad
                                utilizamos un programa que contiene decenas de versiones
                                de la Biblia que pueden ser de mucha utlidad en tu crecimiento.
                            </div>
                        </div>
                        <div class="lcu-col-center">
                            <button-cta
                                :text="'Descarcar e-sword'"
                                :type="'secondary'"
                                :classes="['lcu-mobile-wideBtn']"
                                @on-click="eSwordClick" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="section-public">
                <div class="section-container">
                    <div class="row">
                        <h3 class="lcu-hero-h3 lcu-center-text">
                            LEGACY CHRISTIAN UNIVERSITY
                        </h3>
                    </div>
                    <div class="row">
                        <h1 class="lcu-section-h1 lcu-center-text">
                            ¡Tu futuro ministerial comienza aquí!
                        </h1>
                    </div>
                    <div class="row">
                        <div class="lcu-center-text">
                            <button-cta
                                :text="'Aplicar'"
                                @on-click="$router.push('/inscribirse')" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <Footer />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Footer from 'ç/footer/Footer.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import HeroBanner from '@/components/hero-banner/HeroBanner.vue';
import MobileControls from 'ç/nav/MobileControls.vue';
import IphoneBar from 'ç/nav/iphone-bar/IphoneBar.vue';
import UnauthNav from 'ç/nav/UnauthNav.vue';
import SecondaryNav from 'ç/nav/SecondaryNav.vue';

export default {
  name: 'curriculum-page',
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    UnauthNav,
    SecondaryNav,
    ButtonCta,
    Footer,
    MobileControls,
    IphoneBar,
    HeroBanner,
  },
  methods: {
  eSwordClick() {
    window.open('https://www.e-sword.net/', '_blank', 'noopener,noreferrer');
  },
}
};
</script>

<style scoped lang="scss">
.lcu-curriculum-h2 {
  color: $legacy-primary;
  font-family: 'raleway-bold';
  font-size: 21px;
}

.lcu-col-center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
